import { render, staticRenderFns } from "./view-reporting-technical-drawer.vue?vue&type=template&id=b0980266&scoped=true"
import script from "./view-reporting-technical-drawer.vue?vue&type=script&lang=js"
export * from "./view-reporting-technical-drawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0980266",
  null
  
)

export default component.exports